let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("cSFd6")).then(() => parcelRequire('wgY32'));